import React from 'react';
import Stories from '../components/SNS/Story/Stories';
import WeeklyRank from '../components/SNS/WeeklyRank/WeeklyRank';

function WeeklyRankPage() {
  return (
    <div>
      <Stories />
      <WeeklyRank />
    </div>
  );
}

export default WeeklyRankPage;
